import React from 'react';
import { getAreaIcon } from './areaIcons';

// Mirrors accounts/tab_principal/principal_main.jsx ModuleCard — same square
// tile idiom (icon + label, centered) but denser grid (2/row mobile, 4/row desktop).
// Icon per area via areaIcons.js; unknown areas fall back to MapPinIcon.
const AreaCard = ({ area, onClick }) => {
  const Icon = getAreaIcon(area);
  return (
    <div
      onClick={onClick}
      className="aspect-[5/4] bg-white flex flex-col items-center justify-center hover:shadow-md transition rounded-xl p-2 cursor-pointer"
    >
      <Icon className="w-5 h-5 text-gray-700 mb-1" strokeWidth={2} />
      <span className="text-sm font-medium text-center leading-tight px-1">{area}</span>
    </div>
  );
};

export default AreaCard;
